<template>

    <div>
        <b-card v-if="garden" class="earnings-card">
          
                <b-card-title class="mb-1">
                    <!-- <feather-icon
            icon="ClipboardIcon"
            size="33"
            :class="'text-primary'"
          /> -->
                    <img src="@/assets/icons/information-svgrepo-com.svg" width="30" class="my-svg-alternatex" alt="" />
                    {{ $t('Gardens and Irrigation Statistics' ) }}
                </b-card-title>
         

            


                   
                    <div class="font-small-2">
                        <feather-icon icon="CircleIcon" size="16" :class="'text-primary'" />
                        {{ $t('Garden Service Planned') }} : {{ garden[0] != undefined ? garden[0].GardenServicePlanned
                        : 0
                        }}
                    </div>

                    <div class="font-small-2">
                        <feather-icon icon="CircleIcon" size="16" :class="'text-primary'" />
                        {{ $t('Garden Service Served') }} : {{ garden[0] !== undefined ? garden[0].GardenServiceServed :
                        0
                        }}

                    </div>
                   
                       <b-row>
                            <b-col cols="6" class="text-center"> <span >{{$t('Served')}}</span></b-col>
                        </b-row>
                        <b-progress  animated striped show-progress label="Served"  :value="gardenDone" max="100" height="12px" />

 



               

        </b-card>

    </div>


</template>

<script>
import {
    BCard, BRow, BCol, BCardTitle, BCardText,  BProgress,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'

const $earningsStrokeColor2 = '#28c76f66'
const $earningsStrokeColor3 = '#28c76f33'
export default {
    components: {
        BCard,
        BRow,
        BCol,
        BCardTitle,
        BCardText,
        VueApexCharts,
          BProgress,

    },
    props: {

        garden: {
            type: Array,
            default: () => [],
        },

       

    },
   computed:{
    //    gardenDone() {
    //        let done = 0;
    //        if (this.garden[0] != undefined) {
    //            let total = parseInt(this.garden[0].GardenServicePlanned) + parseInt(this.garden[0].GardenServiceServed)
    //            done = ( parseInt(this.garden[0].GardenServiceServed) / total) * 100
              

    //        }

    //        return Math.round(done);
    //    },
    gardenDone() {
           let done = 0;
           if (this.garden[0] != undefined) {
              
               done = ( parseInt(this.garden[0].GardenServiceCompletion))
              

           }

           return done;
       },

       
         

   }

}
</script>

<style lang="css" scoped>
.vl {
    border-left: 2px solid gray;
    height: 80px;
    width: 0px;
}
</style>>

